import React, { memo } from 'react'
import startCase from 'lodash/startCase'
import toLower from 'lodash/toLower'
import Typography from 'transfix-ui/core/Typography'
import { makeStyles } from 'transfix-ui/core/styles'
import { brandColors } from 'transfix-ui/theme/colors'
import { useUserDetails } from 'utils/hooks/useUserDetails'

const useHomepageHeaderStyles = makeStyles(theme => ({
  headerContainer: {
    padding: `0 ${theme.spacing(2)}`,
    position: 'relative',
    [theme.breakpoints.up('xl')]: {
      padding: `0 ${theme.spacing(4)}`,
    },
  },
  background: {
    background: `linear-gradient(90deg, ${brandColors.coolGray8} 61.85%, ${brandColors.coolGray6} 100%)`,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: `${theme.spacing(6)}`,
    minHeight: `${theme.spacing(20)}`,
  },
  header: {
    padding: `${theme.spacing(11)} 0 ${theme.spacing(3)}`,
    position: 'relative',
    zIndex: 1,
    [theme.breakpoints.up('md')]: {
      padding: `${theme.spacing(7)} 0 ${theme.spacing(3)}`,
    },
  },
  title: {
    fontSize: theme.spacing(4.25),
    fontWeight: 400,
    '& strong': {
      fontWeight: 700,
    },
  },
}))

export interface IHomepageHeaderProps {
  children: JSX.Element
}

const HomepageHeader = memo<IHomepageHeaderProps>(({ children }) => {
  const classes = useHomepageHeaderStyles()
  const { userDetails } = useUserDetails()
  const { firstName = '' } = userDetails || {}
  const firstNameFormatted = startCase(toLower(firstName))

  return (
    <div className={classes.headerContainer}>
      <div className={classes.background} />
      <div className={classes.header}>
        <Typography variant='h2' color='secondary' className={classes.title}>
          Hello, <strong>{firstNameFormatted}</strong>
        </Typography>
      </div>
      {children}
    </div>
  )
})

export default HomepageHeader
